var render, staticRenderFns
import script from "./ControlColor.vue?vue&type=script&lang=js"
export * from "./ControlColor.vue?vue&type=script&lang=js"
import style0 from "./ControlColor.vue?vue&type=style&index=0&id=ec2c6620&prod&lang=scss&scoped=true"
import style1 from "./ControlColor.vue?vue&type=style&index=1&id=ec2c6620&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@2.8.8_vue-template-compiler@2.7.16_webpack@5.101.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2c6620",
  null
  
)

export default component.exports